import type {SelectOption} from "~/types";

export const commonList: SelectOption[] = [
  {label: "Masculino", value: "MALE"},
  {label: "Feminino", value: "FEMALE"},
  {label: "Não Binário", value: "NON_BINARY"},
  {label: "Agênero", value: "AGENDER"},
  {label: "Gênero Fluido", value: "FLUID_GENDER"},
  {label: "Bigênero", value: "BIGENDER"},
  {label: "Travesti", value: "TRAVESTI"},
  {label: "Mulher Trans", value: "TRANS_WOMAN"},
  {label: "Homem Trans", value: "TRANS_MAN"},
  {label: "Prefiro não dizer", value: "PREFER_NOT_TO_SAY"},
]

export const ageGroupList:SelectOption[] = [
  { label: "L (Livre)", value: 0 },
  { label: "6 anos", value: 6 },
  { label: "10 anos", value: 10 },
  { label: "12 anos", value: 12 },
  { label: "14 anos", value: 14 },
  { label: "16 anos", value: 16 },
  { label: "18 anos", value: 18 }
]
